import React, { useState } from 'react';
import { Sheet, Button, Typography, Snackbar, Alert } from '@mui/joy';

const RemoveDeviceDialog = ({ open, device, onClose, onRemoveDevice }) => {
    const [loading, setLoading] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');

    const handleRemoveDevice = async () => {
        setLoading(true);
        try {
            await onRemoveDevice(device.id);
            setSnackbarMessage('Device removed successfully!');
            setSnackbarSeverity('success');
            onClose(); // Close the dialog after success
        } catch (error) {
            setSnackbarMessage('Failed to remove device. Please try again.');
            setSnackbarSeverity('error');
        } finally {
            setLoading(false);
            setSnackbarOpen(true);
        }
    };

    if (!open) return null;

    return (
        <Sheet
            sx={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                bgcolor: 'background.level1',
                boxShadow: 24,
                width: '400px',
                padding: '16px',
                borderRadius: '8px',
                zIndex: 1000,
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Typography level="h6" sx={{ mb: 2 }}>
                Confirm Device Removal
            </Typography>
            <Typography level="body-sm" sx={{ mb: 4 }}>
                Are you sure you want to remove the device: <strong>{device.name}</strong>?
            </Typography>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button variant="outlined" onClick={onClose}>
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    color="danger"
                    onClick={handleRemoveDevice}
                    disabled={loading}
                >
                    {loading ? 'Removing...' : 'Remove'}
                </Button>
            </div>

            {/* Snackbar for success/error messages */}
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={4000}
                onClose={() => setSnackbarOpen(false)}
            >
                <Alert severity={snackbarSeverity} onClose={() => setSnackbarOpen(false)}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Sheet>
    );
};

export default RemoveDeviceDialog;